import { useTranslation } from "react-i18next";
import InputAdornment from "@mui/material/InputAdornment";

import { TestProps } from "shared/types";

import IconButton from "features/components/IconButton";
import TextField from "features/components/TextField";
import CloseIcon from "features/ui/Icons/CloseIcon";
import SearchIcon from "features/ui/Icons/SearchIcon";

import { DEFAULT_WIDTH_CLASS } from "./constants";

interface Props extends TestProps {
  onChange: (value: string) => void;
  searchTerm?: string;
  placeholder?: string;
  className?: string;
}

const SearchInput = ({
  onChange,
  searchTerm = "",
  placeholder,
  className,
  testId = "search-input",
}: Props) => {
  const { t } = useTranslation();
  const placeholderText = placeholder ?? t("common:charts.search");

  return (
    <TextField
      value={searchTerm}
      // MUI's width:100% is unlayered, so it beats any Tailwind width class the caller passes.
      fullWidth={false}
      onChange={({ target: { value } }) => onChange(value)}
      placeholder={placeholderText}
      className={className ?? DEFAULT_WIDTH_CLASS}
      testId={testId}
      slotProps={{
        htmlInput: { "aria-label": placeholderText },
        input: {
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon className="text-gray-400" />
            </InputAdornment>
          ),
          endAdornment: searchTerm ? (
            <InputAdornment position="end">
              <IconButton
                size="small"
                onClick={() => onChange("")}
                testId={`${testId}-clear`}
              >
                <CloseIcon />
              </IconButton>
            </InputAdornment>
          ) : null,
        },
      }}
    />
  );
};

export default SearchInput;
